export default function mapStandardOrderData({
  formCustomerInfo,
  braintreeNonce = null,
  formBillingInfo = {},
  cartToken,
  mobileOptIn = false,
  partialPayment,
  deliveryOption,
  withMembership
}) {
  const orderDeliveryOption = deliveryOption ? { deliveryOption } : {}
  const orderMembership = withMembership ? { withMembership } : {}
  return {
    order: {
      customerInfo: {
        firstName: formCustomerInfo.firstName,
        lastName: formCustomerInfo.lastName,
        email: formCustomerInfo.email,
        password: formCustomerInfo.password,
        password_confirmation: formCustomerInfo.password_confirmation,
        phone: formCustomerInfo.phone,
        streetAddress1: formCustomerInfo.streetAddress1,
        streetAddress2: formCustomerInfo.streetAddress2,
        city: formCustomerInfo.city,
        state: formCustomerInfo.state,
        country: formCustomerInfo.country,
        zip: formCustomerInfo.zip,
        mobileOptIn,
      },
      billingInfo: {
        firstName: formBillingInfo.firstName,
        lastName: formBillingInfo.lastName,
        streetAddress1: formBillingInfo.streetAddress1,
        streetAddress2: formBillingInfo.streetAddress2,
        city: formBillingInfo.city,
        state: formBillingInfo.state,
        country: formBillingInfo.country,
        zip: formBillingInfo.zip,
        cardType: formBillingInfo.cardType,
        lastFourDigits: formBillingInfo.lastFourDigits,
        cardToken: formBillingInfo.cardToken,
        expirationDate: formBillingInfo.expirationDate,
      },
      ...orderDeliveryOption,
      ...orderMembership,
      partialPayment,
      braintreeNonce,
    },
    cartToken: cartToken,
  }
}
